import React from 'react';
import styles from './SuggestionExample.module.scss';
import { Icon, IconList } from 'components/core';
import { Inline } from 'components/layout';

// A picture of a suggestion, not a suggestion. The tick and cross mirror
// SuggestionActionButtons so reviewers recognise the controls they need to
// find, but they are inert and hidden from assistive technology — the real
// controls live on the fields themselves.
export const SuggestionExample = () => (
  <div className={styles.frame}>
    <Inline spacing={2} alignY="center">
      <span className={styles.example}>Suggestion example</span>
      <span aria-hidden="true" className={`${styles.action} ${styles.accept}`}>
        <Icon icon={IconList.solid.faCheck} />
      </span>
      <span aria-hidden="true" className={`${styles.action} ${styles.reject}`}>
        <Icon icon={IconList.solid.faClose} />
      </span>
    </Inline>
  </div>
);
